import React, { Dispatch, SetStateAction, createContext, useContext, useState } from "react";
import PropTypes from "prop-types";
import { ManageShopKeys } from "src/shared/constants/AppEnums";

// @ts-ignore
const DefaultKeyContext = createContext<DefaultKeyValueType>();
export const useDefaultKeyContext = () => useContext(DefaultKeyContext);

export type DefaultKeyValueType = {
    defaultKey: ManageShopKeys,
    setDefaultKey: Dispatch<SetStateAction<ManageShopKeys>>
};

const DefaultKeyContextProvider = ({ children }: any) => {
    const [defaultKey, setDefaultKey] = useState<ManageShopKeys>(ManageShopKeys.General);
    const DefaultKeyValue = {
        defaultKey,
        setDefaultKey
    };
    return (
        <DefaultKeyContext.Provider value={DefaultKeyValue}>
            {children}
        </DefaultKeyContext.Provider>
    );
};

export default DefaultKeyContextProvider;

DefaultKeyContextProvider.propTypes = {
    children: PropTypes.node.isRequired,
};
